import axios from "axios";
import { logout } from "../lib/auth";
import { screenColumnConfigTableColumn } from "../config/screenColumnConfig";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 画面項目設定一覧
export async function getScreenColumnConfigs(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "screenColumnConfigs";
    const params = makeParams(screenColumnConfigTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const screenColumnConfigs: dataDifine[] = response.data.fetch_data;
    const countScreenColumnConfigs: string = response.data.count_data;
    return { screenColumnConfigs, countScreenColumnConfigs };
  } catch (error) {
    // logout();
  }
}

// 画面項目設定登録
export async function postScreenColumnConfig(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "screenColumnConfig";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 画面項目設定削除
export async function deleteScreenColumnConfig(id: string) {
  try {
    const path = "screenColumnConfig";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
